import { render } from "./BlDocumentSignatureWindow.vue?vue&type=template&id=a931c060&scoped=true"
import script from "./BlDocumentSignatureWindow.vue?vue&type=script&lang=js"
export * from "./BlDocumentSignatureWindow.vue?vue&type=script&lang=js"

import "./BlDocumentSignatureWindow.vue?vue&type=style&index=0&id=a931c060&scoped=true&lang=scss"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a931c060"]])

export default __exports__